
import EmptyWalletAdd from "../../../assets/filled/EmptyWalletAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EmptyWalletAddIcon({ className, dataTestid = "EmptyWalletAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EmptyWalletAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
